import { render, staticRenderFns } from "./ClassManage.vue?vue&type=template&id=4847fcaa&scoped=true"
import script from "./ClassManage.vue?vue&type=script&lang=js"
export * from "./ClassManage.vue?vue&type=script&lang=js"
import style0 from "./ClassManage.vue?vue&type=style&index=0&id=4847fcaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4847fcaa",
  null
  
)

export default component.exports